import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../../lib/api";
import { AdminHeader, Modal, ConfirmDelete, EditBtn, AddBtn, Field } from "../../components/admin/AdminUI";
import { Star } from "lucide-react";

const empty = { name: "", designation: "", photo: "", message: "", rating: 5, featured: true };

export default function TestimonialsAdmin() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);
  const [editing, setEditing] = useState(null);
  const load = () => api.get("/admin/testimonials").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.type === "checkbox" ? e.target.checked : (e.target.type === "number" ? Number(e.target.value) : e.target.value) });
  const save = async (e) => {
    e.preventDefault();
    try {
      if (editing) await api.put(`/admin/testimonials/${editing}`, form);
      else await api.post("/admin/testimonials", form);
      toast.success("Saved");
      setOpen(false); setForm(empty); setEditing(null); load();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message); }
  };
  const edit = (t) => { setEditing(t.id); setForm({ ...empty, ...t }); setOpen(true); };
  const del = async (id) => { await api.delete(`/admin/testimonials/${id}`); load(); toast.success("Deleted"); };

  return (
    <div>
      <AdminHeader title="Testimonials" subtitle="Manage member testimonials on the homepage" actions={<AddBtn onClick={() => { setEditing(null); setForm(empty); setOpen(true); }} />} />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {items.map((t) => (
          <div key={t.id} className="card-elev p-6">
            <div className="flex text-brand-accent gap-0.5 mb-3">{Array.from({ length: t.rating || 5 }).map((_, j) => <Star key={j} size={14} fill="currentColor" />)}</div>
            <p className="text-brand-text text-sm">{t.message}</p>
            <div className="flex items-center gap-3 mt-5">
              {t.photo && <img src={t.photo} alt={t.name} className="w-10 h-10 rounded-full object-cover" />}
              <div>
                <div className="font-semibold text-brand-text text-sm">{t.name}</div>
                <div className="text-xs text-brand-muted">{t.designation}</div>
              </div>
            </div>
            <div className="mt-4 flex items-center justify-between border-t border-brand-border pt-3">
              <span className="text-xs text-brand-muted">{t.featured ? "Featured" : "Hidden"}</span>
              <div className="flex items-center gap-1"><EditBtn onClick={() => edit(t)} /><ConfirmDelete onConfirm={() => del(t.id)} /></div>
            </div>
          </div>
        ))}
      </div>
      <Modal open={open} onClose={() => setOpen(false)} title={editing ? "Edit Testimonial" : "New Testimonial"}>
        <form onSubmit={save} className="grid gap-4">
          <Field label="Name *"><input required value={form.name} onChange={upd("name")} className="form-input" /></Field>
          <Field label="Designation"><input value={form.designation} onChange={upd("designation")} className="form-input" /></Field>
          <Field label="Photo URL"><input value={form.photo} onChange={upd("photo")} className="form-input" /></Field>
          <Field label="Message *"><textarea required rows={4} value={form.message} onChange={upd("message")} className="form-input" /></Field>
          <Field label="Rating"><input type="number" min={1} max={5} value={form.rating} onChange={upd("rating")} className="form-input" /></Field>
          <label className="flex items-center gap-2"><input type="checkbox" checked={form.featured} onChange={upd("featured")} /> <span className="text-sm">Featured on homepage</span></label>
          <div className="flex justify-end gap-2"><button type="button" onClick={() => setOpen(false)} className="btn-ghost">Cancel</button><button className="btn-primary">Save</button></div>
        </form>
      </Modal>
    </div>
  );
}
